mutation ReissueParticipantPortalAccess($participantId: ID!, $resetPin: Boolean) {
  reissueParticipantPortalAccess(input: { participantId: $participantId, resetPin: $resetPin }) {
    rawPin
    errors
  }
}
